import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { Button, Grid, Row, Col } from 'react-bootstrap'
import LogistikareView from './LogistikareView'
import GruppaviseringView from './GruppaviseringView'
import CustomView from './CustomView'
import { keyify, getModalStyles } from '../../common/utils'

class MessageGroupsModal extends Component {
    constructor(props) {
        super(props)
    }

    state = { view: 'logistikare' }

    menuItemClicked = (e) => {
        this.setState({ view: e.target.id })
    }

    getView = () => {
        const lock = this.props.keyedLocks[this.props.lockId]
        const { view } = this.state

        return <>
            <LogistikareView style={{ display: view === "logistikare" ? '' : 'none' }} id="logistikare" lock={lock} />

            <GruppaviseringView style={{ display: view === "gruppavisering" ? '' : 'none' }} id="gruppavisering" lock={lock} />

            <br />
            <br />

            <CustomView style={{ display: view === "gruppavisering" ? '' : 'none', maxWidth: '100%' }} id="gruppavisering" lock={lock} />
        </>
    }

    render() {
        if (!this.props.keyedCustomers || !this.props.keyedCompanies || !this.props.keyedLocks) return null

        const { view } = this.state

        return (
            <div>
                <Modal
                    ariaHideApp={false}
                    isOpen={true}
                    onRequestClose={() => this.props.closeModal()}
                    style={getModalStyles()}>

                    <div className="qCloseButton" onClick={() => this.props.closeModal()}>Stäng</div>

                    <Grid fluid style={{ maxWidth: '100%' }}>
                        <Row>
                            <Col lg={12} xs={12} style={{ textAlign: 'center' }}>
                                <h2>Aviseringsinställningar</h2>
                            </Col>
                        </Row>

                        <br />

                        <Row style={{ height: '50vh', backgroundColor: 'none' }}>
                            <Col lg={3} xs={12} style={{ borderRight: window.isMobile ? 'none' : '1px solid lightgrey', borderBottom: !window.isMobile ? 'none' : '1px solid lightgrey', textAlign: 'center', marginBottom: 20, paddingLeft: 0 }}>
                                <ul style={{ listStyleType: 'none', paddingLeft: 0 }} onClick={this.menuItemClicked}>
                                    <li className="qListItem" style={{ color: view === "logistikare" ? '#006e78' : 'black' }} id="logistikare">Logistikare</li>
                                    <li className="qListItem" style={{ color: view === "gruppavisering" ? '#006e78' : 'black' }} id="gruppavisering">Gruppavisering</li>
                                </ul>
                            </Col>

                            <Col lg={9} xs={12}>
                                {this.getView()}
                            </Col>
                        </Row>

                    </Grid>

                </Modal>
            </div >
        )
    }
}

const mapStateToProps = state => {
    const keyedLocks = keyify(state.collectionData.locks, '_id')

    return {
        keyedCustomers: state.collectionData.keyedCustomers,
        keyedCompanies: state.collectionData.companies.keyedCompanies,
        keyedLocks
    }
}

const mapDispatch = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatch)(MessageGroupsModal)